import Icon from '../components/Icon.vue'

Icon.register({
  'photo-video': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 0c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32h-128v-320h-192v64h-160v-96c0-17.7 14.3-32 32-32h448zM232 103v-30c0-5-4-9-9-9h-30c-5 0-9 4-9 9v30c0 5 4 9 9 9h30c5 0 9-4 9-9zM584 311v-30c0-5-4-9-9-9h-30c-5 0-9 4-9 9v30c0 5 4 9 9 9h30c5 0 9-4 9-9zM584 207v-30c0-5-4-9-9-9h-30c-5 0-9 4-9 9v30c0 5 4 9 9 9h30c5 0 9-4 9-9zM584 103v-30c0-5-4-9-9-9h-30c-5 0-9 4-9 9v30c0 5 4 9 9 9h30c5 0 9-4 9-9zM416 160c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32v-288c0-17.7 14.3-32 32-32h384zM96 224c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM384 448v-96l-96-96-128 128-32-32-64 64v32h320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/photo-video.js
// module id = 1636
// module chunks = 0